// @flow
import React from 'react';

import {
  Cell,
} from './styled';

type Props = {
  style: Object,
};

const ListFooterCellRenderer = ({ style }: Props) => (
  <Cell style={style} />
);

export default ListFooterCellRenderer;
